<template>
  <div>
    <el-tag
      v-for="(category, index) in params.data.userCategory"
      v-bind:key="index"
      type="primary"
      effect="dark"
      class="ml-2 el-button--primary"
    >
      {{ category.name }}
    </el-tag>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'categoryBadges'
});
</script>
